import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Compass } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-white" data-id="element-96">
      {/* Subtle decorative background elements */}
      <div className="absolute inset-0 pointer-events-none opacity-5" data-id="element-97">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-600 rounded-full mix-blend-multiply filter blur-3xl" data-id="element-98"></div>
        <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-amber-500 rounded-full mix-blend-multiply filter blur-3xl" data-id="element-99"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto space-y-8" data-id="element-101">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-teal-50 text-teal-700 font-medium text-sm mb-4" data-id="element-102">
            <Compass size={16} data-id="element-103" />
            <span data-id="element-104">Welcome to the Knowledge Activation Company</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 tracking-tight leading-tight" data-id="element-105">
            Innovation starts with a{' '}
            <span className="text-teal-600" data-id="element-106">conversation.</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-107">
            Latteware, Inc. builds systems that transform human experience into
            living knowledge—connecting people, uncovering opportunities, and
            turning insights into action.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8" data-id="element-108">
            <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-md font-semibold text-lg transition-all shadow-sm hover:shadow-md" data-id="element-109">
              Start Your First Conversation
              <ArrowRight size={20} data-id="element-110" />
            </button>
            <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-white border-2 border-gray-200 hover:border-teal-600 hover:text-teal-600 text-gray-700 px-8 py-4 rounded-md font-semibold text-lg transition-all" data-id="element-111">
              Explore the Ecosystem
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}